export const APP_NAME_PROJECT = 'Sofynest';
export const APP_DESCRIPTION_PROJECT = 'Sistema softnest';
export const APP_DESKTOP_WIDTH = 992;

export const API_URL_BASE = process.env.REACT_APP_API_URL;
// export const APP_API_LOYVERSE_URL = process.env.REACT_APP_API_LOYVERSE_URL;
export const APP_API_LOYVERSE_URL = process.env.REACT_APP_API_LOYVERSE_URL;

export const APP_AUTHORIZE_KEY = process.env.REACT_APP_AUTHORIZE_KEY || '-';

export const MODE = process.env.REACT_APP_MODE || '-';

export const API_URL_NUPY = process.env.REACT_APP_API_URL || '-';

